export default __webpack_public_path__ + "static/media/fontMulish400_cyrilli.6893fb76.woff2";